var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Star = function Star(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.993 1.002a1 1 0 0 1 .897.557l2.853 5.782 6.38.924a1 1 0 0 1 .554 1.707l-4.623 4.5 1.09 6.354a1 1 0 0 1-1.452 1.054l-5.693-3-5.706 3a1 1 0 0 1-1.45-1.054l1.09-6.354-4.623-4.5a1 1 0 0 1 .554-1.707l6.38-.924 2.852-5.782a1 1 0 0 1 .897-.557Zm0 3.26-2.19 4.436a1 1 0 0 1-.753.547l-4.892.709 3.547 3.451a1 1 0 0 1 .288.886l-.837 4.876 4.379-2.302a1 1 0 0 1 .931 0l4.363 2.3-.836-4.874a1 1 0 0 1 .289-.886l3.546-3.451-4.892-.71a1 1 0 0 1-.754-.546l-2.189-4.436Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Star;